/*
Example state:

export default {
  config: {
    officeHours: {
      timezone: 'America/New_York',
      monday: [{ start: '8:00', stop: '18:00' }],
      tuesday: [{ start: '8:00', stop: '18:00' }],
      wednesday: [{ start: '8:00', stop: '18:00' }],
      thursday: [{ start: '8:00', stop: '18:00' }],
      friday: [{ start: '8:00', stop: '18:00' }],
      saturday: [{ start: '8:00', stop: '16:00' }],
      sunday: [{ start: '8:00', stop: '16:00' }],
    },
    welcomeMessage: 'welcome',
    colors: {
      buttonBackground: '#000000',
      buttonText: '#FFFFFF',
      outgoingBubble: '#FFFFFF',
      incomingBubble: '#FFFFFF',
      outgoingBubbleBorder: '#DDDDDD',
      incomingBubbleBorder: '#DDDDDD',
      outgoingBubbleText: '#000000',
      incomingBubbleText: '#000000',
      incomingLink: '#0000FF',
      outgoingLink: '#0000FF',
      submitArrow: '#000000'
    },

    demoSelfServiceEnabled: false,
    onboarding: {
      header: 'Let\'s Chat',
      introMessage: 'Hi there! Tell us a bit about yourself.',
      nameField: 'Your name',
      emailField: 'Your email',
      submitButton: 'Let\'s Go',
    },
    display: 'ALL_PAGES', // options: [ALL_PAGES, RULES_ONLY, DISABLED]; default: ALL_PAGES
    rules: {
      "/gifts":  {
        "delay": 10, // in seconds
        "message": "Please let us know if you need help...", // message to display
      }
    }
  }
  },
  cohortId: '8',
};

*/

export default {
  config: {
    /* 
      authenticatedTagName should only be used to track 
      in Amplitude if user is logged in on our customer's
      website. It should be removed when we have an authenticated
      user chat flow.
    */
    authenticatedTagName: undefined,
    alwaysShow: false,
    border: {
      color: '',
      width: '0px',
    },
    borderRadius: 'LARGE',
    colors: {},
    display: 'ALL_PAGES',
    dropshadowEnabled: true,
    font: "'Helvetica Neue', Helvetica, sans-serif",
    initialChatButton: {
      type: 'TEXT',
      value: 'Live Chat',
    },
    isDraggable: false,

    onboarding: {
      enabled: true,
      header: "Let's Chat",
      introMessage: 'Hi there! Tell us a bit about yourself.',
      nameField: 'Your name',
      emailField: 'Your email',
      submitButton: "Let's Go",
    },

    ongoingChat: {
      welcomeMessage: 'Hello <<USERNAME>>! How can we help?',
      title: "Let's Chat",
      endMessageAgentEnded:
        'Thanks for chatting <<USERNAME>>! More questions? Chat again to pick up where we left off.',
      endMessageTimeExpired:
        'Thanks for chatting <<USERNAME>>! More questions? Chat again to pick up where we left off.',
      endMessageConsumerNoReply:
        "We haven't heard from you in a while, <<USERNAME>>. Type another message to pick up where we left off.",
      endChatTitle: 'Chat has ended',
    },

    rules: {},
    zIndex: 2147483000,

    // DEMO ONLY
    demoSelfServiceEnabled: false,
  },
  cohortId: null,
};
